import {
    ResourceBudgetProposalAssociationT,
    ResourceSoftwareIdField,
} from 'routes/BudgetModule/config/types';
import type { InscriptionT } from 'routes/BudgetModule/shared/entities/inscription';

export const getInitialChoice = (
    budgetProposalResources: ResourceBudgetProposalAssociationT[],
    resourceSoftwareIdField: ResourceSoftwareIdField,
    selectedInscription: InscriptionT,
): {
    budgetProposalResource: ResourceBudgetProposalAssociationT | null;
    budgetLine: null;
} => ({
    budgetProposalResource:
        budgetProposalResources.length > 0
            ? budgetProposalResources.find(
                  (budgetProposalResource) =>
                      budgetProposalResource &&
                      budgetProposalResource.resource &&
                      budgetProposalResource.resource.resourceSoftwareId ===
                          selectedInscription[resourceSoftwareIdField],
              ) || budgetProposalResources[0]
            : null,
    budgetLine: null,
});
